import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { forwardRef } from 'react';
import { getRGBA } from '../../../utils/getRGBA/getRGBA.js';
import '../../Icons/Add.js';
import '../../Icons/Application.js';
import '../../Icons/AppStore.js';
import '../../Icons/Arrow.js';
import '../../Icons/At.js';
import '../../Icons/Attach.js';
import '../../Icons/Bank.js';
import '../../Icons/Battery.js';
import '../../Icons/Bell.js';
import '../../Icons/Blocked.js';
import Calendar from '../../Icons/Calendar.js';
import '../../Icons/Card.js';
import '../../Icons/CaretDown.js';
import '../../Icons/CaretLeft.js';
import '../../Icons/CaretRight.js';
import '../../Icons/CaretUp.js';
import '../../Icons/Checkbox.js';
import '../../Icons/CheckboxChecked.js';
import '../../Icons/CheckboxIndeterminate.js';
import '../../Icons/ChevronLeft.js';
import '../../Icons/ChevronRight.js';
import '../../Icons/Company.js';
import '../../Icons/Copy.js';
import '../../Icons/Currency.js';
import '../../Icons/Customers.js';
import '../../Icons/Dash.js';
import '../../Icons/Dashboard.js';
import '../../Icons/DirectionDown.js';
import '../../Icons/DirectionUp.js';
import '../../Icons/Document.js';
import '../../Icons/DoubleChevronLeft.js';
import '../../Icons/DoubleChevronRight.js';
import '../../Icons/DoubleDirectionDown.js';
import '../../Icons/DoubleDirectionUp.js';
import '../../Icons/Download.js';
import '../../Icons/Edit.js';
import '../../Icons/ExclamationMark.js';
import '../../Icons/ExclamationMarkFilled.js';
import '../../Icons/ExternalLink.js';
import '../../Icons/EyeClosed.js';
import '../../Icons/EyeOpen.js';
import '../../Icons/Fingerprint.js';
import '../../Icons/Folder.js';
import '../../Icons/Forever.js';
import '../../Icons/Funnel.js';
import '../../Icons/GooglePlay.js';
import '../../Icons/Iban.js';
import '../../Icons/Id.js';
import '../../Icons/Info.js';
import '../../Icons/InfoFilled.js';
import '../../Icons/Instant.js';
import '../../Icons/Ip.js';
import '../../Icons/Link.js';
import '../../Icons/List.js';
import '../../Icons/Mail.js';
import '../../Icons/Menu.js';
import '../../Icons/Message.js';
import '../../Icons/MessageDot.js';
import '../../Icons/Onboarding.js';
import '../../Icons/Padlock.js';
import '../../Icons/PadlockOpen.js';
import '../../Icons/Percent.js';
import '../../Icons/Play.js';
import '../../Icons/PowerOff.js';
import '../../Icons/ProcessCompleted.js';
import '../../Icons/ProcessCountEight.js';
import '../../Icons/ProcessCountFive.js';
import '../../Icons/ProcessCountFour.js';
import '../../Icons/ProcessCountNineAndMore.js';
import '../../Icons/ProcessCountOne.js';
import '../../Icons/ProcessCountSeven.js';
import '../../Icons/ProcessCountSix.js';
import '../../Icons/ProcessCountThree.js';
import '../../Icons/ProcessCountTwo.js';
import '../../Icons/ProcessFailed.js';
import '../../Icons/ProcessInProgress.js';
import '../../Icons/ProcessNotStarted.js';
import '../../Icons/ProcessPartialInProgress.js';
import '../../Icons/ProcessPaused.js';
import '../../Icons/Profile.js';
import '../../Icons/Progress.js';
import '../../Icons/Provider.js';
import '../../Icons/QuestionMark.js';
import '../../Icons/QuestionMarkFilled.js';
import '../../Icons/Remove.js';
import '../../Icons/Repeat.js';
import '../../Icons/Reset.js';
import '../../Icons/RoundArrow.js';
import '../../Icons/RoundArrowFilled.js';
import '../../Icons/RoundCheckOutlined.js';
import '../../Icons/RoundCheckOutlinedFilled.js';
import '../../Icons/RoundClose.js';
import '../../Icons/RoundCloseFilled.js';
import '../../Icons/RoundLeft.js';
import '../../Icons/RoundLeftFilled.js';
import '../../Icons/RoundMinus.js';
import '../../Icons/RoundMinusFilled.js';
import '../../Icons/RoundPlus.js';
import '../../Icons/RoundPlusFilled.js';
import '../../Icons/RoundRight.js';
import '../../Icons/RoundRightFilled.js';
import '../../Icons/Settings.js';
import '../../Icons/SettingsCog.js';
import '../../Icons/Shield.js';
import '../../Icons/StarFilled.js';
import '../../Icons/StarOutlined.js';
import '../../Icons/Success.js';
import '../../Icons/Timer.js';
import '../../Icons/Trash.js';
import '../../Icons/Upload.js';
import '../../Icons/User.js';
import '../../Icons/VerticalDots.js';
import '../../Icons/World.js';
import '../../Icons/Wrench.js';
import '../../Icons/Zoom.js';
import { Input } from '../../Input/Input.js';
import { useBaseInput } from './useBaseInput.js';

const BaseInput = forwardRef(function BaseInput(props, ref) {
    const { "data-testid": dataTestId } = props, inputProps = __rest(props, ["data-testid"]);
    const testId = dataTestId !== null && dataTestId !== void 0 ? dataTestId : "datepicker";
    const inputTestId = `${testId}-input`;
    const iconTestId = `${testId}-calendar-icon`;
    const { baseInputProps, baseInputRef, handleClickIcon } = useBaseInput({
        inputProps,
        ref,
    });
    return (jsx(StyledInput, Object.assign({}, baseInputProps, { "data-testid": inputTestId, ref: baseInputRef, endAdornment: jsx(IconWrapper, { "data-testid": iconTestId, onClick: handleClickIcon, children: jsx(Calendar, {}) }) })));
});
const StyledInput = styled(Input)(({ theme, error }) => (Object.assign(Object.assign({ textTransform: "lowercase" }, (!error && { color: theme.palette.text.high })), { input: {
        padding: theme.spacing(1, 1, 1, 1.25),
    }, "::selection": {
        backgroundColor: getRGBA(theme.palette.primary.main, 0.1),
    }, "::placeholder, ::selection": Object.assign({ textTransform: "lowercase" }, (!error && { color: theme.palette.text.secondary })) })));
const IconWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    cursor: "pointer",
    padding: theme.spacing(1, 1.25, 1, 1),
}));

export { BaseInput };
//# sourceMappingURL=BaseInput.js.map
